(function($) {

	/*------------------------------------*\
	    ANY

	    This will return true if there are any items
	    in a jQuery collection.

	    EXAMPLE

	    var items = $(".item");

	    if(items.any()) {
			console.log("YAY!");
		}
	\*------------------------------------*/

	$.fn.any = function() {
		return $(this).length > 0;
	}

    /*------------------------------------*\
        LOG

        Pass in log paramaters and the app will log for you

        EXAMPLE

        $.log("hey there");

    \*------------------------------------*/

    $.extend({
        log: function (parameter) {

            if (window.console) {
                console.log(parameter);
            }
        }
    });

    /*------------------------------------*\
        PARSE SETTINGS

        This will try and parse inline json settings as an object literal to pass into a plugin

        EXAMPLE

        <div class="item" data-settings='{"setting1": true}'></div>

        var item = $(".item"),
            settings = item.parseSettings();

        console.log(settings.setting1);

        returns true;

    \*------------------------------------*/
    $.fn.parseSettings = function () {

        var elem = $(this),
            response = {};

        if (elem.attr("data-settings")) {

            try {
                response = $.parseJSON(elem.attr("data-settings"));
            }
            catch (ex) {
                $.log("Check input data. Message: " + ex.message);
                return {};
            }
        }

        return response;
    };


    /*------------------------------------*\
        AJAX REQUEST

        A nice Ajax wrapper method

        EXAMPLE

        $.ajaxRequest({
            url: "/test",
            callback(function(data, isSuccess) {

                if(isSuccess) {
                    alert('All the data is WINNING');
                }
            });
        });

    \*------------------------------------*/
	$.extend({
		ajaxRequest: function(options) {

			var settings = {
                dataType: "application/json",
                url: "/",
                data: {},
                method: "GET",
                callback: null
			};

			var init = function() {

				settings = $.extend(true, {}, settings, options);

				$.ajax({
					contentType: settings.dataType,
					url: settings.url,
					data: settings.data,
					type: settings.method,
					success: function(responseData) {
						tryCallback(responseData);
					},
					error: function(responseData) {
						tryCallback(responseData);
					}
				});
			},

			tryCallback = function(responseData) {

				if(typeof(settings.callback) == "function") {
					settings.callback(responseData, (responseData != null ? (responseData.status == 200 ? false : true) : true));
				}
			}

			init();

		}
	});

    /*------------------------------------*\
        AJAX HTML

        A warpper to ajaxRequest for simple HTML getting

        EXAMPLE

        $.ajaxHtml('http://google.com', function(data) {
			// do stuff
		});

    \*------------------------------------*/
	$.extend({
		ajaxHtml: function(url, callback) {
			$.ajaxRequest({
				dataType: "text/html",
				url: url,
				callback: callback
			});
		}
	});


    /*------------------------------------*\
        ESC

        A useful little wrapper for the escape key press event

        EXAMPLE

		$.esc({
			callback: function(evt) {

				// Close your modal or whatever. Accessibility FTW
			}
		});

    \*------------------------------------*/
	$.extend({
		esc: function(options) {

			var settings = {
				callback: null
			}

			settings = $.extend(true, {}, settings, options);

			if(typeof(settings.callback) == 'function') {

				$(document).keyup(function(evt) {

					// escape key maps to keycode `27`
					if (evt.keyCode == 27) {

						// run callback and pass the event over
						settings.callback(evt);
					}
				});
			}

		}
	});

    /*------------------------------------*\
        LEVEL HEIGHTS

        This will level the heights of a collection of items.
        Simply add the selector as an option. Selector must be a
        child element of the item.

        EXAMPLE

        var item = $(".item");

        item.levelHeights({
            selector: ".items-to-be-level"
        });

    \*------------------------------------*/

    $.fn.levelHeights = function (options) {

        var elem = $(this),
            items = [],
            maxHeight = 0,
            settings = {
                selector: ""
            }

        var init = function () {

            settings = $.extend(true, {}, settings, options);

            if (settings.selector.length > 0) {

                // Load items
                items = elem.find(settings.selector);

                if (items.any()) {

                    // Loop each item and find the max height
                    items.each(function () {

                        var item = $(this);

                        if (item.height() > maxHeight) {

                            maxHeight = item.height();
                        }
                    });

                    // If max height set, set the heights
                    if (maxHeight > 0) {

                        items.height(maxHeight);
                    }
                }
            }
        };

        init();
        return this;
    };

    /*------------------------------------*\
        RENDER TEMPLATE

        A little wrapper to call on nunjucks and a precompiled template

        EXAMPLE

        var template = $.renderTemplate('test', {"name": "Bill"});

    \*------------------------------------*/
    $.extend({
    	renderTemplate: function(template, data) {

    		if(typeof(template) == 'undefined') {
    			return '';
    		}

    		if(typeof(nunjucks) == 'undefined') {
    			return '';
    		}

    		if(typeof(data) == 'undefined') {
    			data = {};
    		}

    		var engine = new nunjucks.Environment();

    		return engine.render((template + '.html'), data);
    	}
    });

    /*------------------------------------*\
        CHANGE EVENT

        A helper to return the correct 'change' event for an element

        EXAMPLE

        var event = $('.item').changeEvent();

    \*------------------------------------*/
    $.fn.changeEvent = function() {
      return 'change';
    };

    /*------------------------------------*\
        QUERY STRING

        A helper to work with query strings

        toJson: take the current query string and return it as json
        fromJson: takes a json object and converts into a query string

    \*------------------------------------*/
    $.extend({
    	queryString: {

    		toJson: function(ignoreKeys) {
				var response = {},
					data = window.location.href.toString().toLowerCase(),
					splitData = [];

				// Return empty object if undefined
				if(typeof(data) == 'undefined') {
					return {};
				}

				// Return empty object if empty
				if(data.length == 0) {
					return {};
				}

				// Set empty array if ignore keys not set
				if(typeof(ignoreKeys) == 'undefined') {
					ignoreKeys = [];
				}

				// Split query string into array
				splitData = data.split('?')[1].split('&');

				// Loop and create key value pairs
				for (var i = 0, l = splitData.length; i < l; i++) {
				    var param = splitData[i].split('=');
				    response[param[0]] = param[1];
				}

				// Check ignore keys length
				if(ignoreKeys.length > 0) {

					// Loop each one and delete if exists
					$.each(ignoreKeys, function(i, val) {

						if(response.hasOwnProperty(val)) {
							delete response[val];
						}
					});

				}

				return response;
    		},

    		fromJson: function(data) {
    			return '?' + $.param(data).replace('?', '&');
    		}
    	}
    });

    /*------------------------------------*\
        IS OVERFLOWING

        Determine if an elements content is overflowing. Returns true or false.

		EXAMPLE

		$('.elem').isOverflowing()

    \*------------------------------------*/
    $.fn.isOverflowing = function() {

    	var elem = $(this)[0];

    	// Get current overflow value
		var curOverflow = elem.style.overflow;

		// Set as hidden if undefined or visible
		if (!curOverflow || curOverflow === 'visible') {
	  		elem.style.overflow = 'hidden';
		}

		// Determine if overflowing
		var isOverflowing = elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight;

		// Set back
		elem.style.overflow = curOverflow;

		return isOverflowing;
    }

	/*------------------------------------*\
        NL2BR

        Convert newlines to br tags

		EXAMPLE

		var desc = $.nl2br('hello\nmate');

		RETURNS

		var desc = 'hello<br />mate'

    \*------------------------------------*/
	$.extend({
		nl2br: function (text) {

			return (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2');
		}
	});

	/*------------------------------------*\
        LIMIT STRING

        Limit string length and add ellipsis if longer than limit

		EXAMPLE

		var desc = $.limitString('hello mate', 5);

		RETURNS

		var desc = 'hello...';

    \*------------------------------------*/
	$.extend({
		limitString: function (text, limit) {

			// Strip HTML
			text = text.replace(/(<([^>]+)>)/ig, '');

			// If no limit set default
			if(typeof(limit) == 'undefined') {
				limit = 50;
			}

			// If there's no need to limit then return content
			if(text.length <= limit) {
				return text;
			}

			// Limit and add ellipsis
			else {
				return text.trim().substring(0, limit) + '...'
			}

		}
	});

	/*------------------------------------*\
        TO CAMEL CASE

		Turns oh-hai-there to ohHaiThere
	\*------------------------------------*/
	$.extend({
		toCamelCase: function(str) {

			var firstPass = str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
						    	return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
						    }).replace(/\s+/g, '');

			return firstPass.replace('-', '');
		}
	});

	/*------------------------------------*\
        GET BREAKPOINT

		Returns the current CSS breakpoint as defined in global.scss
	\*------------------------------------*/
	$.extend({
		getBreakpoint: function() {
			return window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
		}
	});

}($));

// TAKEN FROM David Walsh blog - http://davidwalsh.name/javascript-debounce-function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};
